import Vue from 'vue';
var vueObject = new Vue({

})
export default  vueObject;


// WEBPACK FOOTER //
// ./src/bus.js